import { Link, NavLink } from 'react-router-dom';
import DiscordIcon from './DiscordIcon.jsx';

export default function Header({ me, links }) {
  return (
    <header className="site-header">
      <Link className="brand" to="/" aria-label="KozelSMP">
        <img src="/assets/logo.png" alt="" />
        <span>KozelSMP</span>
      </Link>

      <nav className="nav-links" aria-label="Основная навигация">
        <NavLink className="nav-link" to="/">Главная</NavLink>
        <NavLink className="nav-link" to="/players">Игроки</NavLink>
        <NavLink className="nav-link" to="/feed">Лента</NavLink>
        <NavLink className="nav-link" to="/donate">Донат</NavLink>
        <a className="nav-link" href={links.wiki} target="_blank" rel="noreferrer">Вики</a>
        <NavLink className="nav-link" to="/map">Карта</NavLink>
      </nav>

      <div className="header-actions">
        {me?.user ? (
          <Link className="user-chip" to="/myprofile">
            <img src={me.user.avatarUrl || '/assets/logo.png'} alt="" />
            <span>{me.user.displayName}</span>
          </Link>
        ) : (
          <md-filled-tonal-button onClick={() => (window.location.href = '/auth/login?returnTo=/myprofile')}>
            <DiscordIcon className="button-icon" slot="icon" />
            Войти
          </md-filled-tonal-button>
        )}
      </div>
    </header>
  );
}
